import { render, staticRenderFns } from "./changeList.vue?vue&type=template&id=21d5aa66&scoped=true"
import script from "./changeList.vue?vue&type=script&lang=js"
export * from "./changeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d5aa66",
  null
  
)

export default component.exports